import React from 'react';
import { CustomerCartProvider, useCart } from './CustomerCartContext.jsx';
import Navbar from '../defaultComponents/Navbar.jsx';
import Footer from '../defaultComponents/Footer.jsx';

import styled from 'styled-components';

const PageWrapper = styled.div`
  font-family: Inter;
  
  background: #f8f8f8;
`

const CartBanner = styled.div`
  min-height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`

const CartBannerTitle = styled.div`
  width: 75vw;
  font-size: 2.5vw;

  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-weight: bold;
`

const CartBox = styled.div`
  width: 75vw;

  display: grid;

  grid-template-columns: 6fr 4fr;
  gap: 1%;
`

const CartBoxGridLeft= styled.div`

  display: flex;
  flex-direction: column;

  gap: 1vh;
`

const CartBoxItem = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;
  background: white;

  padding: 1vw;

  display: flex;

  height: 20vh;
`

const CartBoxItemImage = styled.div`
  background: papayawhip;
  height: 100%;
  width: 20%;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const CartBoxItemDesc = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  
  padding-left: 1vw;

  width: 100%;
`

const CartBoxItemTitle = styled.div`
  font-size: 1.5vw;
  text-transform: uppercase;

  display: flex;
  justify-content: space-between;
`

const CartBoxItemRemove = styled.div`
  color: darkgrey;
  text-transform: lowercase;
  font-size: 0.8rem;
  text-decoration: underline;

  cursor: pointer;
`

const CartBoxItemQuantity = styled.div`
  font-size: 1vw;
  color: #777777;
`

const CartBoxItemDateRange = styled.div`
  font-size: 1vw;
  color: #777777;
`

const CartBoxItemTotal = styled.div`
  font-size: 1.3vw;
  font-weight: bold;
  font-family: Montserrat;
`

const CartBoxGridRight = styled.div`
`

const CartBoxSummary = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;
  background: white;

  font-family: Montserrat;
  font-weight: bold;
`

const CartBoxSummaryTitle = styled.div`
  font-size: 1vw;
  padding: 1vw;
  font-weight: bold;

  border-bottom: 1px solid #E3E4E6;
`

const CartBoxSummaryContainer = styled.div`
  font-size: 1.2vw;
  padding: 1vw;
`

const CartBoxSummaryEntry = styled.div`
  font-size: 1.5vw;

  display: flex;
  justify-content: space-between;
`

export default function CustomerCartPage() {
  const { cart, addToCart } = useCart();

  const [total, setTotal] = React.useState(0)

  const calculateCartTotal = () => {
    let currTotal = 0;
    for(let i = 0; i < cart.length; i++) {
      currTotal += parseInt(cart[i].rateTotal)
    }

    setTotal(currTotal)
  }

  React.useEffect(()=>{
    calculateCartTotal()
  },[])

  return (
    <>
      <Navbar />
      <PageWrapper>
        <CartBanner>
          <CartBannerTitle>
            <div>Hire Details</div>
          </CartBannerTitle>
          <CartBox>
            <CartBoxGridLeft>
              {cart.map((item, idx)=>(
                <CartBoxItem key={idx}>
                  <CartBoxItemImage>{item.name} IMAGE</CartBoxItemImage>
                  <CartBoxItemDesc>
                    <CartBoxItemTitle>
                      <div>{item.name}</div>
                      <CartBoxItemRemove>remove</CartBoxItemRemove>
                    </CartBoxItemTitle>
                    <CartBoxItemQuantity>{item.quantity}</CartBoxItemQuantity>
                    <CartBoxItemDateRange>{item.startDate} {item.startTime} - {item.endDate} {item.endTime}</CartBoxItemDateRange>
                    <CartBoxItemTotal>${item.rateTotal}</CartBoxItemTotal>
                  </CartBoxItemDesc>
                </CartBoxItem>
              ))}
            </CartBoxGridLeft>
            <CartBoxGridRight>
              <CartBoxSummary>
                <CartBoxSummaryTitle>Summary</CartBoxSummaryTitle>  
                <CartBoxSummaryContainer>
                  <CartBoxSummaryEntry>
                    <div>Total:</div>
                    <div>${total}</div>
                    </CartBoxSummaryEntry>
                </CartBoxSummaryContainer>
              </CartBoxSummary>
            </CartBoxGridRight>
          </CartBox>
        </CartBanner>
        <Footer />
      </PageWrapper>
    </>
  );
}
